import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import { appGetAllSanstha } from '../../store/sanstha'
import { appCreateAnnouncement } from '../../store/announcement'
import { toCamelCase } from '../../utils/Function'

function NewAnnouncement() {
	const { id } = useParams()
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const { isloder } = useSelector(state => state.annoucementReducer)
	const { sanstha } = useSelector(state => state.sansthaReducer)
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	useEffect(() => {
		dispatch(appGetAllSanstha({ page: 1, limit: 1000, hub: hubId || permissionOfHub }))
	}, [dispatch])

	const formik = useFormik({
		initialValues: {
			title: '',
			body: '',
			hub: hubId || permissionOfHub,
			sanstha: '',
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			body: Yup.string()
				.transform(value => {
					if (!value) return ''
					return value
						.replace(/<[^>]+>/g, '')
						.replace(/&nbsp;/gi, '')
						.trim()
				})
				.test('is-not-empty', 'Body is required', value => value && value.length > 0)
				.required('Body is required'),
			title: Yup.string().required('Title is required'),
			//   sanstha: Yup.string().required("Sanstha is required"),
		}),
		onSubmit: values => {
			const temp_obj = {
				title: values.title,
				body: values?.body,
				sanstha: values?.sanstha,
				hub: hubId || permissionOfHub,
				navigate: navigate,
			}
			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)
			if (id) {
			} else {
				dispatch(appCreateAnnouncement(filtered_obj)).then(() => {
					formik.resetForm()
				})
			}
		},
	})

	return (
		<>
			{isloder && <div className="loading">Loading...</div>}
			<div className="">
				<div className="card card-default">
					<div className="card-body">
						<form onSubmit={formik.handleSubmit}>
							<div className="row mb-3">
								<div className="col-md-6">
									<label>Sanstha</label>
									<Select
										options={
											Array.isArray(sanstha)
												? sanstha.map(place => ({
														value: place._id,
														label: toCamelCase(place?.name),
												  }))
												: []
										}
										onChange={opt => formik.setFieldValue('sanstha', opt?.value)}
										value={
											Array.isArray(sanstha)
												? sanstha
														.filter(option => option._id === formik?.values?.sanstha)
														.map(option => ({
															value: option._id,
															label: toCamelCase(option?.name),
														}))[0]
												: null
										}
										key={formik.values.sanstha}
										placeholder="Select Sanstha.."
									/>
									{/* {formik.touched.sanstha && formik.errors.sanstha && (
                    <div className="text-danger">{formik.errors.sanstha}</div>
                  )} */}
								</div>
							</div>
							<div className="row">
								<div className="col-md-6">
									<div className="form-group">
										<label>Send notification admins and teams</label>
										<select
											className="form-control"
											name="approval_required"
											value={formik.values.approval_required}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
										>
											<option value="">Select option</option>
											<option value="Users">Users</option>
											<option value="Admins & teams"> Admins & teams</option>{' '}
										</select>

										{formik.touched.approval_required && formik.errors.approval_required && (
											<div className="text-danger text-sm mt-1">
												{formik.errors.approval_required}
											</div>
										)}
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-md-6">
									<label>
										Title <span className="text-danger">*</span>
									</label>
									<input
										type="text"
										name="title"
										className="form-control"
										value={formik.values.title}
										onChange={formik.handleChange}
										placeholder="Enter title"
									/>
									{formik.touched.title && formik.errors.title && (
										<div className="text-danger">{formik.errors.title}</div>
									)}
								</div>
								<div className="col-md-6">
									<label>
										Body <span className="text-danger">*</span>
									</label>
									<textarea
										className="form-control"
										name="body"
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.body}
										rows="3"
									/>

									{formik.touched.body && formik.errors.body && (
										<div className="text-danger">{formik.errors.body}</div>
									)}
								</div>
							</div>

							<div className="text-center mt-4">
								<button type="submit" className="btn btn-success mr-2">
									<i className="fa fa-check me-1"></i>
									save
								</button>
								<button type="button" className="btn btn-secondary">
									<i className="fa fa-times me-1"></i> Cancel
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	)
}
export default NewAnnouncement
